import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Global } from '@services/core/Global';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProcessCategoryService {
  private http = inject(HttpClient);
  private base = Global.url + 'V1/process-category-ref';

  get(activeOnly = false): Observable<any[]> {
    const params = activeOnly ? { activeOnly: 'true' } : {};
    return this.http.get<any[]>(this.base, { params });
  }

  create(data: any): Observable<any> {
    return this.http.post(this.base, data);
  }

  update(uuid: string, data: any): Observable<any> {
    return this.http.put(`${this.base}/${uuid}`, data);
  }

  delete(uuid: string): Observable<any> {
    return this.http.delete(`${this.base}/${uuid}`);
  }
}
